import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Controller, useForm } from 'react-hook-form';
import { ListAllIntershipsOfTheMonthResponseDto, ReadPersonSelectDto } from '@/api.types';
import { SelectGenerico } from '@/shared/components/forms/SelectGenerico';
import { changeResponsible } from '../../attendance-sheet.service';
import { readPersonResponsibleSelect } from '@/modules/people/person.service';
import { toast } from 'react-toastify';
import { useContext, useEffect, useMemo, useState } from 'react';
import MyContext from '@/shared/contexts/AppContext';
import { useNavigationView } from '@/shared/hooks/useNavigationView';
import { ehPerfilColaborador, filtrarResponsaveisParaPessoa } from '../pages/perMonth/perMonthFilters.utils';

type Formulario = {
  responsavel?: ReadPersonSelectDto;
};

interface IMyProps {
  show: boolean;
  folha: ListAllIntershipsOfTheMonthResponseDto;
  handleHide: (e: | React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement> | HTMLElement) => void;
}

export default function ModalResponsavel({ show, handleHide, folha }: IMyProps) {

  const context = useContext(MyContext);
  const { authVisao } = context ?? {};
  const { effectiveView } = useNavigationView();
  const restringirAoProprio = useMemo(
    () => ehPerfilColaborador(authVisao ?? null, effectiveView),
    [authVisao, effectiveView],
  );
  const pessoaIdSessao = context?.state?.pessoaId;

  const [executing, setExecuting] = useState<boolean>()
  const [pessoas, setPessoas] = useState<ReadPersonSelectDto[]>([])

  const toResponsavelSelectDto = (pessoa: IMyProps['folha']['responsavel']): ReadPersonSelectDto | undefined => {
    if (!pessoa) return undefined;
    return { id: pessoa.id as unknown as string, nome: pessoa.nome };
  };

  const { control, handleSubmit, reset } = useForm<Formulario>({
    defaultValues: {
      responsavel: toResponsavelSelectDto(folha.responsavel),
    },
  });

  useEffect(() => {
    if (!show) return;

    readPersonResponsibleSelect()
      .then((res) => {
        const [items] = (res ?? []) as unknown as [ReadPersonSelectDto[], number];
        const lista = items ?? [];
        if (restringirAoProprio) {
          setPessoas(
            filtrarResponsaveisParaPessoa(
              lista.map((p) => ({ label: p.nome ?? '', value: p.id })),
              pessoaIdSessao,
            ).map((p) => ({ id: String(p.value), nome: p.label })),
          );
        } else {
          setPessoas(lista);
        }
      })
      .catch(() => toast.error('Falha ao carregar responsáveis.'));
  }, [show, restringirAoProprio, pessoaIdSessao]);

  useEffect(() => {
    reset({
      responsavel: toResponsavelSelectDto(folha.responsavel),
    });
  }, [folha, reset]);


  const onSubmit = (data: Formulario) => {
    setExecuting(true)

    changeResponsible(folha.folha.id, data.responsavel ? data.responsavel.id : "0")
      .then((res) => {
        toast.info(String(res))
      })
      .catch((res) => {
        toast.error(String(res))
      })
      .finally(() => {
        setExecuting(false)
      })
  };


  return (
    <Modal show={show} aria-labelledby="contained-modal-title-vcenter" centered onExit={handleHide}>
      <Modal.Header closeButton={false}>
        <Modal.Title id="contained-modal-title-vcenter">
          Definição de Responsável
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit(onSubmit)}>

        <Modal.Body>
          <p>Defina quem é o responsável por essa folha de frequência:</p>
          <Controller
            name="responsavel"
            control={control}
            render={({ field }) => (
              <SelectGenerico
                id="responsavel"
                name="responsavel"
                value={field.value}
                onChange={field.onChange}
                onBlur={field.onBlur}
                items={pessoas}
                getOptionLabel={(p) => p.nome!}
                getOptionValue={(p) => p.id}
                isClearable={true}
              />
            )}
          />

        </Modal.Body>
        <Modal.Footer className="text-left">
          <Button
            variant="primary"
            type='submit'
            className="btn-success text-left"
            disabled={executing}>
            {executing ? 'Aguarde...' : 'Definir'}
          </Button>
          <Button variant="secondary" onClick={handleHide}>
            Fechar
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
